var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tree',{attrs:{"load-data":_vm.onLoadData,"tree-data":_vm.treeData}})}
var staticRenderFns = []

export { render, staticRenderFns }